module.exports = {"TXTCLI_Back":{"id":"TXTCLI_Back","defaultMessage":"Retour","flags":["TRACK"],"track":"Back"}}